import {
  FETCH_SALE_ORDER,
  RESET_SALE_ORDER,
} from "../../constants/action.constants";

const initialState = {
  data: {},
  others: {},
};

const saleOrderView = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_SALE_ORDER:
      return { data: action.payload, others: action.others };
    case RESET_SALE_ORDER:
      return initialState;
    default:
      return state;
  }
};

export default saleOrderView;
